<template>
  <div class="personal-wrap">
    <div class="personal-title">任务结果通知方式</div>
    <el-form :model="form">
      <div class="personal-blocks">
        <div class="item">
          <div class="itemh"><el-checkbox v-model="form.email" /><span>邮箱</span></div>
          <el-input placeholder="通知邮箱账号" v-model="form.emailReceiver" :disabled="!form.email" />
        </div>
        <div class="item">
          <div class="itemh"><el-checkbox v-model="form.weixin" /><span>企业微信</span></div>
          <el-input placeholder="通知群聊机器人URL" v-model="form.weixinKey" :disabled="!form.weixin" />
        </div>
        <div class="item">
          <div class="itemh"><el-checkbox v-model="form.feishu" /><span>飞书</span></div>
          <el-input placeholder="通知群聊机器人URL" v-model="form.feishuUrl" :disabled="!form.feishu" />
        </div>
        <div class="item">
          <div class="itemh"><el-checkbox v-model="form.dingding" /><span>钉钉</span></div>
          <el-input placeholder="钉钉secret" v-model="form.dingdingSecret" :disabled="!form.dingding" />
          <el-input placeholder="钉钉access-token" v-model="form.dingdingAccessToken" :disabled="!form.dingding" />
        </div>
      </div>
    </el-form>
    <el-button type="primary" style="margin-top: 24px;" @click="setResultNotify">保存修改</el-button>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import * as Request from '@/assets/request'
  import { ElMessage } from 'element-plus'

  const form = ref({});

  const getResultNotify = async () => {
    const result = await Request.post({
      url: `/22001/facade/commons/notify/result/getResultNotify`
    });
    if(result?.code != 200) return;

    form.value.dingding = result?.data?.dingding || false
    form.value.dingdingAccessToken = result?.data?.dingdingAccessToken || ''
    form.value.dingdingSecret = result?.data?.dingdingSecret || ''
    form.value.email = result?.data?.email || false
    form.value.emailReceiver = result?.data?.emailReceiver || ''
    form.value.feishu = result?.data?.feishu || false
    form.value.feishuUrl = result?.data?.feishuUrl || ''
    form.value.weixin = result?.data?.weixin || false
    form.value.weixinKey = result?.data?.weixinKey || ''
  }
  onMounted(() => {
    getResultNotify()
  })

  const setResultNotify = async () => {
    const result = await Request.post({
      url: `/22001/facade/commons/notify/result/setResultNotify`,
      data: form.value
    });
    if(result?.code != 200) return;

    ElMessage.success('操作成功');
  }
</script>

<style scoped lang="less">
  @import "./index.less";
</style>